export function handleAxiosException( exception ) {
  if ( !exception ) {
    exception = new Error( 'Cannot connect to server' )
    exception.description = 'Sorry we cannot connect to the server, please check your internet connection or reload the page. If it still cannot, please contact the technician team for further investigation.'
  }
  else if ( exception.response ) {
    const data = exception.response.data

    if ( data && data.error && data.error.message ) {
      exception.message = data.error.message
    }
    else {
      exception.message = 'Oops,... it seems that there is an error'
    }
  }

  return exception
}

export default handleAxiosException
